import type { DayOffRequest } from '../../../../../../shared/dpRequests';
import type { VacationApprovalItem } from '@/features/Vacations/models/vacationApproval.types';
import type { DayOffApproval, VacationApproval } from '../approvals.types';

export interface DayOffProfile {
    role?: string | null;
    squad?: string | null;
}

export function fromVacation(item: VacationApprovalItem): VacationApproval {
    const { request } = item;
    return {
        id: request.id,
        kind: 'vacation',
        collaboratorName: request.collaboratorName,
        collaboratorEmail: request.collaboratorEmail,
        requestedAt: request.requestedAt?.toDate?.() ?? null,
        isPending: request.status === 'PendingManager',
        item,
    };
}

export function fromDayOff(request: DayOffRequest, profile?: DayOffProfile): DayOffApproval {
    return {
        id: request.id,
        kind: 'day_off',
        collaboratorName: request.collaboratorName || request.collaboratorEmail,
        collaboratorEmail: request.collaboratorEmail,
        requestedAt: request.createdAt?.toDate?.() ?? null,
        isPending: request.status === 'pending_manager' && !request.managerDecision,
        request,
        collaboratorRole: profile?.role ?? null,
        collaboratorSquad: profile?.squad ?? null,
    };
}
